import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import {
  ConstructionType,
  LookupItemViewModel,
  SystemProfileViewModel,
} from '../models/keying-models';
import { HierarchyConfig } from '../configuration/keying.hierarchy.environment.config';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private profile: ReplaySubject<SystemProfileViewModel> = new ReplaySubject(1);
  profile$ = this.profile.asObservable();

  constructor(
    @Inject(HttpClient) private httpClient: HttpClient,
    private hierarchyConfig: HierarchyConfig
  ) {}

  setProfile(profile: SystemProfileViewModel) {
    this.profile.next(profile);
  }

  // **Master Key System Profiles */

  getChambers(systemTypeId: number, keywayFamilyTypeId: number) {
    const url = `${this.hierarchyConfig.getKeyingUrl()}Lookups/s${systemTypeId}/k${keywayFamilyTypeId}?type=keyingChamberType`;
    return this.httpClient.get<LookupItemViewModel[]>(url);
  }

  getConstructionKeyTypes(
    systemTypeId: number,
    keywayFamilyTypeId: number,
    chamberTypeId: number
  ) {
    const url = `${this.hierarchyConfig.getKeyingUrl()}Lookups/s${systemTypeId}/k${keywayFamilyTypeId}/c${chamberTypeId}`;
    return this.httpClient.get<ConstructionType[]>(url);
  }
}
